// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divDayItem {
  color: white;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 95%;
  margin: 0.1em 0.2em;
  border-radius: 5px;
  padding: 2px 5px;
  font-family: Calibri, sans-serif !important;
  font-size: 0.8vw;
}

.divMoreItems {
  display: block;
  font-family: Calibri, sans-serif !important;
  font-weight: bold;
  margin: 0.15em 0.2em;
  text-align: center;
  font-size: 0.8vw;
}

.sessionItemContainer {
  display: flex;
  flex-direction: column;
}

.calendarSquircle-container {
  margin-top: 38px;
  display: flex;
  flex-direction: column;
}

.calendarSquircle-header {
  border-color: #6e6e6e;
  border-radius: 10px 10px 0 0;
  border-style: solid;
  border-width: thin;
  font-family: Calibri, sans-serif !important;
  font-size: 30px;
  font-weight: bold;
  background-color: #eaeaea;
  height: 68px !important;
  margin: 0px 0px 0px 17px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 98%;
}

.calendarSquircle-body {
  border-color: #6e6e6e;
  border-radius: 0px 0px 10px 10px;
  border-style: solid;
  border-top-style: none;
  border-width: thin;
  font-family: Calibri, sans-serif !important;
  align-self: stretch;
  flex-grow: 2;
  padding: 5px;
  height: 80%;
  background-color: #f8f8f8;
  margin: 0px 0px 0px 17px;
  width: 98%;
  overflow: auto;
  font-size: 1.15vw;
}

.sessionContainer {
  display: flex;
  margin: 30px 0;
  width: 95%;
}

.sessionDetailGroup {
  margin-left: 15px;
  display: flex;
  white-space: nowrap;
  margin-bottom: -5px;
  margin-top: -5px;
}

.sessionDetailStatusGroup {
  margin-left: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  margin-bottom: -5px;
  margin-top: -5px;
}

.sessionDetailLabel {
  font-weight: bolder;
  padding-right: 5px;
  white-space: nowrap;
}

.sessionDetailLine {
  display: flex;
  width: 85%;
  max-width: 85%;
}

.sessionDetailData {
  max-width: 80%;
  width: 80%;
}

.sessionButtonDiv {
  margin-left: 15px;
  padding: 10px 0 0 0;
}

.squircleILTCalendarContainer {
  border: 1px;
  border-color: gray;
  border-style: solid;
  border-radius: 10px;
  box-shadow:
    rgba(0, 0, 0, 0.075) 0px 1px 1px inset,
    rgba(102, 175, 233, 0.6) 0px 0px 8px !important;
  padding: 0.75em 0.5em;
}

.squircleILTCalendarContainerDetailPopupHeader {
  border-radius: 10px 10px 0 0;
  margin-bottom: 0.5px;
  padding: 0.3em 0.5em;
  & button {
    all: unset;
    float: right;
    font-weight: normal;
    text-decoration: underline;
  }
}

.squircleILTCalendarContainerDetailPopupBody {
  border-radius: 0 0 10px 10px;
  font-family: Calibri, sans-serif;
  font-size: 14px;
  padding: 0.75em 0;
}

.iLTCalendarDetailPopupGroup {
  display: flex;
  white-space: nowrap;
}

.iltcalendar-ellipsis-menu {
  > .MuiMenu-paper {
    border: 1px solid #a4a4a4;
    background-color: #f4f4f4;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 3px;
    margin-top: 4px;
    > .MuiMenu-list {
      padding: 0px;

      > .MuiMenuItem-root {
        padding: 3px;
        justify-content: center;
        align-items: center;
        width: 55px;
        height: auto;
        font-size: 12px;
        color: #5b5656;
        line-height: normal;
      }
    }
  }
}

.iltcalendar-menu-item:hover {
  background-color: #fafbff !important;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/iltcalendar/iltcalendar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB;;mDAEiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,oBAAoB;EACpB;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;EAC5B;AACF;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf;MACE,YAAY;;MAEZ;QACE,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,eAAe;QACf,cAAc;QACd,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".divDayItem {\n  color: white;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 95%;\n  margin: 0.1em 0.2em;\n  border-radius: 5px;\n  padding: 2px 5px;\n  font-family: Calibri, sans-serif !important;\n  font-size: 0.8vw;\n}\n\n.divMoreItems {\n  display: block;\n  font-family: Calibri, sans-serif !important;\n  font-weight: bold;\n  margin: 0.15em 0.2em;\n  text-align: center;\n  font-size: 0.8vw;\n}\n\n.sessionItemContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.calendarSquircle-container {\n  margin-top: 38px;\n  display: flex;\n  flex-direction: column;\n}\n\n.calendarSquircle-header {\n  border-color: #6e6e6e;\n  border-radius: 10px 10px 0 0;\n  border-style: solid;\n  border-width: thin;\n  font-family: Calibri, sans-serif !important;\n  font-size: 30px;\n  font-weight: bold;\n  background-color: #eaeaea;\n  height: 68px !important;\n  margin: 0px 0px 0px 17px;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 98%;\n}\n\n.calendarSquircle-body {\n  border-color: #6e6e6e;\n  border-radius: 0px 0px 10px 10px;\n  border-style: solid;\n  border-top-style: none;\n  border-width: thin;\n  font-family: Calibri, sans-serif !important;\n  align-self: stretch;\n  flex-grow: 2;\n  padding: 5px;\n  height: 80%;\n  background-color: #f8f8f8;\n  margin: 0px 0px 0px 17px;\n  width: 98%;\n  overflow: auto;\n  font-size: 1.15vw;\n}\n\n.sessionContainer {\n  display: flex;\n  margin: 30px 0;\n  width: 95%;\n}\n\n.sessionDetailGroup {\n  margin-left: 15px;\n  display: flex;\n  white-space: nowrap;\n  margin-bottom: -5px;\n  margin-top: -5px;\n}\n\n.sessionDetailStatusGroup {\n  margin-left: 15px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  white-space: nowrap;\n  margin-bottom: -5px;\n  margin-top: -5px;\n}\n\n.sessionDetailLabel {\n  font-weight: bolder;\n  padding-right: 5px;\n  white-space: nowrap;\n}\n\n.sessionDetailLine {\n  display: flex;\n  width: 85%;\n  max-width: 85%;\n}\n\n.sessionDetailData {\n  max-width: 80%;\n  width: 80%;\n}\n\n.sessionButtonDiv {\n  margin-left: 15px;\n  padding: 10px 0 0 0;\n}\n\n.squircleILTCalendarContainer {\n  border: 1px;\n  border-color: gray;\n  border-style: solid;\n  border-radius: 10px;\n  box-shadow:\n    rgba(0, 0, 0, 0.075) 0px 1px 1px inset,\n    rgba(102, 175, 233, 0.6) 0px 0px 8px !important;\n  padding: 0.75em 0.5em;\n}\n\n.squircleILTCalendarContainerDetailPopupHeader {\n  border-radius: 10px 10px 0 0;\n  margin-bottom: 0.5px;\n  padding: 0.3em 0.5em;\n  & button {\n    all: unset;\n    float: right;\n    font-weight: normal;\n    text-decoration: underline;\n  }\n}\n\n.squircleILTCalendarContainerDetailPopupBody {\n  border-radius: 0 0 10px 10px;\n  font-family: Calibri, sans-serif;\n  font-size: 14px;\n  padding: 0.75em 0;\n}\n\n.iLTCalendarDetailPopupGroup {\n  display: flex;\n  white-space: nowrap;\n}\n\n.iltcalendar-ellipsis-menu {\n  > .MuiMenu-paper {\n    border: 1px solid #a4a4a4;\n    background-color: #f4f4f4;\n    border-radius: 3px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left: 3px;\n    margin-top: 4px;\n    > .MuiMenu-list {\n      padding: 0px;\n\n      > .MuiMenuItem-root {\n        padding: 3px;\n        justify-content: center;\n        align-items: center;\n        width: 55px;\n        height: auto;\n        font-size: 12px;\n        color: #5b5656;\n        line-height: normal;\n      }\n    }\n  }\n}\n\n.iltcalendar-menu-item:hover {\n  background-color: #fafbff !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
